import {Component, OnInit, ViewChild} from '@angular/core';
import {PconsSearchComponent} from './pcons-search/pcons-search.component';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {LogicalConjunctionService} from '../../services/common/logical-conjunction/logical-conjunction.service';
import {MatDialog} from '@angular/material/dialog';
import {CacProfilesApiService} from '../../services/api/routing/cac-profiles/cac-profiles-api.service';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import Search from '../../utils/search';
import {PageEvent} from '@angular/material/paginator';
import {VoipPeerApiService} from '../../services/api/network/online/voip-peer/voip-peer-api.service';
import {PeerConnectionApiService} from '../../services/api/peer-connection/peer-connection-api.service';
import * as _ from 'lodash';
import {CallsQuotaApiService} from '../../services/api/settings/routing/calls-quota/calls-quota-api.service';
import {NodeApiService} from '../../services/api/network/online/node/node-api.service';
import {SipReasonsApiService} from '../../services/api/routing/sip-reason/sip-reasons-api.service';
import {AttributeManipulationGroupsApiService} from '../../services/api/settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {QualityBasedRoutingApiService} from '../../services/api/settings/routing/quality-based-routing/quality-based-routing-api.service';
import {OperativeStatePipe} from '../../pipes/operative-state/operative-state.pipe';
import {PeerConnectionStatusPipe} from './peer-connection-status.pipe';
import {PconsAdminStatePipe} from './pcons-admin-state.pipe';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {PconsDialogService} from './pcons-dialog/pcons-dialog.service';
import {VirtualPconsDialogService} from './virtual-pcons-dialog/virtual-pcons-dialog.service';
import {ShortCallsProfilesApiService} from '../../services/api/settings/routing/short-calls-profiles/short-calls-profiles-api.service';


@Component({
  selector: 'arm-pcons',
  templateUrl: './pcons.component.html',
  styleUrls: ['./pcons.component.scss']
})
export class PconsComponent implements OnInit {
  // Search related params
  operStateOptions = [
    {text: 'Available', value: 'AVAILABLE'},
    {text: 'Unavailable', value: 'UNAVAILABLE'},
    {text: 'Predeleted', value: 'PREDELETED'}
  ];

  adminStateSearchOptions = [
    {text: 'Locked', value: 'LOCKED'},
    {text: 'Locked Incoming', value: 'LOCKED_INCOMING'},
    {text: 'Locked Outgoing', value: 'LOCKED_OUTGOING'},
    {text: 'Unlocked', value: 'UNLOCKED'}
  ];

  qualityOptions = [
    {text: 'Good', value: 'GOOD'},
    {text: 'Fair', value: 'FAIR'},
    {text: 'Bad', value: 'BAD'},
    {text: 'Unknown', value: 'UNKNOWN'}
  ];

  cacStateOptions = [
    { text: 'Unblock', value: 'UNBLOCK' },
    { text: 'Blocked', value: 'BLOCK' },
    { text: 'Blocked for Incoming', value: 'BLOCK_INCOMING' },
    { text: 'Blocked for Outgoing', value: 'BLOCK_OUTGOING' },
  ];

  callDirectionOptions = [
    {text: 'Incoming' , value: 'IN'},
    {text: 'Outgoing' , value: 'OUT'},
  ];

  voipPeersOptions;
  attrManipulation;
  callsQuotaOptions;
  cacProfilesOptions;
  sipReasonsOptions;
  advancedConditions;
  voipPeersMap;
  nodesOptions: any ;
  shortCallsProfilesOptions;

  pconsSearchComponent = PconsSearchComponent;
  searchData: any = {};
  searchTerms: SearchTermDefinitionInf[];

  // search object that returns from search text field + search dialog
  search: any = {};

  // Table related variables
  data = {elements: [], totalElements: 0};
  selection;
  isMultipleSelection = true;
  length: any;

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'status', display: 'Status', selected: true, width: 200, transformer: PeerConnectionStatusPipe},
    {name: 'nodeName', display: 'Node', selected: true, width: 200},
    {name: 'name', display: 'Name', selected: true, width: 200},
    {name: 'voipPeerName', display: 'Voip Peer', selected: true, width: 200},
    {name: 'nativeName', display: 'IP Group', selected: true, width: 200},
    {name: 'operState', display: 'Operative State', selected: true, width: 200, transformer: OperativeStatePipe},
    {name: 'adminState', display: 'Administrative State', selected: true, width: 200, transformer: PconsAdminStatePipe},
    {name: 'result', display: 'Quality', selected: true, width: 200},
    {name: 'callsQuotaName', display: 'Calls Quota', selected: true, width: 200},
    {name: 'cacProfileName', display: 'CAC Profile', selected: true, width: 200},
    {name: 'sipReasonGroupName', display: 'Alternative SIP reason', selected: true, width: 200},
    {name: 'customerId', display: 'SecureLogix - Customer Id', selected: true, width: 200},
    {name: 'callDirection', display: 'SecureLogix - call Direction', selected: true, width: 230}
  ];
  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  // other
  isUnauthorized: boolean;

  constructor(private voipPeerApiService: VoipPeerApiService,
              private pconsService: PeerConnectionApiService,
              private pconsDialogService: PconsDialogService,
              private virtualPconsDialogService: VirtualPconsDialogService,
              private snackBarService: SnackBarService,
              private userPrivilege: UserPrivilegeService,
              private logicalConjunctionService: LogicalConjunctionService,
              public dialog: MatDialog,
              private callsQuotaService: CallsQuotaApiService,
              private nodeApiService: NodeApiService,
              private cacProfilesService: CacProfilesApiService,
              private sipReasonsService: SipReasonsApiService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService,
              private qualityBasedRoutingApiService: QualityBasedRoutingApiService,
              private shortCallsProfilesApiService: ShortCallsProfilesApiService,
              private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  refresh(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    Promise.all([
      this.pconsService.getPCons(params),
      this.voipPeerApiService.getVoipPeers(),
      this.callsQuotaService.getCallsQuotas().toPromise(),
      this.nodeApiService.getNodes(),
      this.cacProfilesService.getCacProfiles().toPromise(),
      this.sipReasonsService.getSipReasonGroups().toPromise(),
      this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().toPromise(),
      this.qualityBasedRoutingApiService.getQualityBasedRoutingSettings().toPromise(),
      this.shortCallsProfilesApiService.getShortCallsProfiles().toPromise()
    ]).then((data) => {
      const voipPeers = data[1].elements;

      this.data = data[0];
      this.length = data[0].totalElements;
      this.voipPeersMap = _.keyBy(voipPeers, 'id');
      this.addAdditionalData(this.voipPeersMap);
      this.setSearchOptions(voipPeers, data[2].elements, data[3], data[4].elements, data[5], data[6], data[7], data[8].elements);
      this.loaderService.hideMainContainer();
    }).catch(() => {
      this.loaderService.hideMainContainer();
      console.log('Exception was thrown in refresh function');
    });
  }

  addAdditionalData(voipPeersMap): void {
    this.data.elements = this.modifyConnectionsForGrid(this.data.elements, voipPeersMap);
    this.setQualityParameters(this.data.elements);
    this.setSecureLogixCallDirection(this.data.elements);
  }

  private setSearchOptions(voipPeers, callsQuota, nodes, cacProfiles, sipReasonsGroups, attrManipulation, advancedConditions, shortCallsProfiles): void {
    this.voipPeersOptions = Search.generateSearchOptions(voipPeers, 'name', 'id');
    this.attrManipulation = Search.generateSearchOptions(attrManipulation, 'groupName', 'id');
    this.callsQuotaOptions = Search.generateSearchOptions(callsQuota, 'name', 'id');
    this.cacProfilesOptions = Search.generateSearchOptions(cacProfiles, 'name', 'id');
    this.sipReasonsOptions = Search.generateSearchOptions(sipReasonsGroups, 'name', 'id');
    this.advancedConditions = advancedConditions;
    
    this.shortCallsProfilesOptions = Search.generateSearchOptions(shortCallsProfiles, 'name', 'id');

    this.nodesOptions = Search.generateSearchOptions(nodes, 'name', 'id');

    this.searchData = {
      data: {},
      operStateOptions: this.operStateOptions,
      adminStateSearchOptions: this.adminStateSearchOptions,
      qualityOptions: this.qualityOptions,
      callsQuotaOptions: this.callsQuotaOptions,
      nodesOptions: this.nodesOptions,
      cacProfilesOptions: this.cacProfilesOptions,
      sipReasonsOptions: this.sipReasonsOptions,
      cacStateOptions: this.cacStateOptions,
      voipPeersOptions: this.voipPeersOptions,
      callDirectionOptions : this.callDirectionOptions,
    };


    this.searchTerms = [
      {term: 'operativeState', operator: '=', displayName: 'Operative State',
        displayValue: Search.getOptionValue(this.operStateOptions)},
      {term: 'adminState', operator: '=', displayName: 'Administrative State',
        displayValue: Search.getOptionValue(this.adminStateSearchOptions)},
      {term: 'quality', operator: '=', displayName: 'Quality',
        displayValue: Search.getOptionValue(this.qualityOptions)},
      {term: 'callsQuotaId', operator: '=', displayName: 'Calls Quota',
        displayValue: Search.getOptionValue(this.callsQuotaOptions)},
      {term: 'cacProfileId', operator: '=', displayName: 'Cac Profile',
        displayValue: Search.getOptionValue(this.cacProfilesOptions)},
      {term: 'sipReasonGroupId', operator: '=', displayName: 'Sip Reason Group',
        displayValue: Search.getOptionValue(this.sipReasonsOptions)},
      {term: 'nodeId', operator: '=', displayName: 'Node',
        displayValue: Search.getOptionValue(this.nodesOptions)},
      {term: 'cacState', operator: '=', displayName: 'CAC State' ,
        displayValue: Search.getOptionValue(this.cacStateOptions)},
      {term: 'voipPeerId', operator: '=', displayName: 'VoIP Peer',
        displayValue: Search.getOptionValue(this.voipPeersOptions)},
      {term: 'callDirection', operator: '=', displayName: 'SecureLogix - call Direction',
        displayValue: Search.getOptionValue(this.callDirectionOptions)}
    ];
  }

  refreshItems(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    this.pconsService.getPCons(params).then(data => {
      this.data = data;
      this.length = data.totalElements;
      this.addAdditionalData(this.voipPeersMap);
      this.loaderService.hideMainContainer();
    }).catch((error) => {
      this.loaderService.hideMainContainer();
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;
    this.refreshItems();
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refreshItems();
  }

  modifyConnectionsForGrid(peerConnections, voipPeersMap): any {
    return peerConnections.map((peerConnection) => {
      peerConnection.voipPeerName = voipPeersMap[peerConnection.voipPeerId].name;
      peerConnection.status = this.getPeerConnectionStatus(peerConnection);
      /*  let leftArrowColor;
        if (peerConnection.adminState === 'LOCKED') {
            leftArrowColor = 'grey';
        } else {
            leftArrowColor = peerConnection.operState === 'AVAILABLE' ? 'green' : 'red';
        }
        peerConnection.name = {
            text: peerConnection.name,
            line: {color: 'grey', length: 200, type: 'dash'},
            arrows: {left: leftArrowColor, right: 'grey'}
        };*/
      return peerConnection;
    });
  }

  getPeerConnectionStatus(peerConnection): string {
    if (peerConnection.adminState === 'LOCKED' ||
      peerConnection.adminState === 'LOCKED_INCOMING' ||
      peerConnection.adminState === 'LOCKED_OUTGOING') {

      return peerConnection.adminState;
    }

    return peerConnection.operState === 'AVAILABLE' ? 'OK' : 'NOT_OK';
  }

  setQualityParameters(elements): void {
    elements.forEach((e) => {
      e.quality.MOS.value = e.quality.MOS.measurement === -1 ? 'UNKNOWN' : e.quality.MOS.measurement;
      e.quality.ASR.value = e.quality.ASR.measurement === -1 ? 'UNKNOWN' : e.quality.ASR.measurement;
    });
  }

  setSecureLogixCallDirection(elements): void {
    elements.forEach((e) => {
      if (e.callDirection) {
        e.callDirection = (this.callDirectionOptions.find(option => option.value === e.callDirection)).text;
      }
    });
  }

  syncTopology(): void {

  }

  lockIncoming(): void {
    this.pconsService.lockIncomingPCons(this.selection.map(pCon => pCon.id))
      .then(() => this.refresh());
  }

  lockOutgoing(): void {
    this.pconsService.lockOutgoingPCons(this.selection.map(pCon => pCon.id))
      .then(() => this.refresh());
  }

  lock(): void {
    this.pconsService.lockPCons(this.selection.map(pCon => pCon.id))
      .then(() => this.refresh());
  }

  unlock(): void {
    this.pconsService.unlockPCons(this.selection.map(pCon => pCon.id))
      .then(() => this.refresh());
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  editItem(): void {
    const selectedItem = _.cloneDeep(this.selection[0]);
    const onSuccess = () => { this.refresh(); };

    if (this.selection[0].peerConnectionNodeType === 'Virtual') {
      // this.editVirtualPcon();
      this.virtualPconsDialogService.editVirtualPcon(selectedItem, this.voipPeersOptions, onSuccess);
    } else {
      // this.editPCon();
      this.pconsDialogService.editPCon(selectedItem, this.voipPeersOptions, this.attrManipulation,
        this.callsQuotaOptions, this.cacProfilesOptions, this.sipReasonsOptions, this.advancedConditions, 
        this.shortCallsProfilesOptions, onSuccess);
    }
  }

  removeItem(): void {
    this.pconsDialogService.remove(this.selection[0], () => {
      this.refresh();
    });
   /* const confirmationMessage = `Are you sure you want to delete the peer connection: "${this.selection[0].name}"?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.pconsService.deletePCon(this.selection[0].id).then(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.logicalConjunctionService
          .generateAndDescription(this.selection, 'name')} successfully deleted`);
      });
    });*/
  }

  isPConDeleteDisabled(): boolean {
    if (this.isPeerConnectionSelected()) {
      return !this.selection.every(this.deletePConIsLegal);
    }

    return true;
  }

  deletePConIsLegal(pCon): boolean {
    return (pCon.peerConnectionNodeType === 'Virtual') ||
      (pCon.adminState === 'LOCKED' && pCon.operState === 'PREDELETED');
  }

  isPeerConnectionSelected(): boolean {
    return this.selection && this.selection.length > 0;
  }

  selectedItemAdminState(): string {
    return this.selection &&
    this.selection[0] &&
    this.selection[0].adminState ?
      this.selection[0].adminState : null;
  }

  isSelectedVirtualPeerConnection(): boolean {
    return this.selection &&
      this.selection[0] && this.selection[0].peerConnectionNodeType === 'Virtual';
  }

  isSingleSelection(): boolean {
    return this.selection && this.selection.length === 1;
  }

/*  private editPCon(): void {
    this.pconsService.getPcon(this.selection[0].id).then(pCon => {
      const dialogRef = this.dialog.open(PconsDialogComponent, {
        data: {
          selectedItem: _.cloneDeep(pCon),
          voipPeers: this.voipPeersOptions,
          attrManipulation: this.attrManipulation,
          callsQuotas: this.callsQuotaOptions,
          cacProfiles: this.cacProfilesOptions,
          sipReasonGroups: this.sipReasonsOptions,
          advancedConditions: this.advancedConditions
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.pconsService.editPCon(result.selectedItem, this.selection[0].id).then(() => {
          dialogRef.close();
          this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
          this.refresh();
        });
      });
    });
  }

  private editVirtualPcon(): void {
    this.pconsService.getPcon(this.selection[0].id).then(pCon => {
      const dialogRef = this.dialog.open(VirtualPconsDialogComponent, {
        data: {
          selectedItem: _.cloneDeep(pCon),
          voipPeers: this.voipPeersOptions
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.pconsService.editPCon(result.selectedItem, this.selection[0].id).then(() => {
          dialogRef.close();
          this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
          this.refresh();
        });
      });
    });
  }*/
}
